import ScrollMagic from 'scrollmagic';
import { ScrollMagicPluginIndicator} from "scrollmagic-plugins";
import anime from 'animejs/lib/anime.es';
import 'simplebar';

import Utils from '../helpers/utils.js';

class PrevEditions {
  constructor(el) {
    this.el = el;

    this.containerAnimatedEl = this.el.querySelector('[data-prev-editions-animation]');
    this.containerShadowEl = this.el.querySelector('[data-prev-editions-shadow]');

    this.editionsShadowEls = this.containerShadowEl.querySelectorAll('.prev-editions__row');

    this.editionsEls = this.containerAnimatedEl.querySelectorAll('.prev-editions__row');
    this.oneEditionHeaderEl = this.editionsEls[0].querySelector('.prev-editions__row-header');

    this.animations = {};

    this.animationsDuration = 1000;

    this.smController = new ScrollMagic.Controller();

    this.editionHeaderHeight = this.oneEditionHeaderEl.getBoundingClientRect().height;
    this.fullEditionHeight = this.editionsShadowEls[0].getBoundingClientRect().height;

    this.duration = document.documentElement.scrollHeight - document.documentElement.clientHeight;

    this.init();
  }

  init() {
    this.editionsEls.forEach((el, index) => {
      this.animations['animation-'+ index] = {
        anim: undefined,
        params: {
          targets: el,
          maxHeight: () => [this.editionHeaderHeight , this.fullEditionHeight],
          direction: 'alternate',
          easing: 'linear',
          autoplay: false,
          duration: () => this.animationsDuration / this.editionsEls.length,
          delay: () => this._getDelayOnAnim(index),
          easing: () => {
            return (t) => {
              return -0.5 * Math.cos(2 * Math.PI * t) + 0.5;
            }
          }
        }
      }
    });

    this.editionsEls.forEach((el, index) => {
      this._initAnimation('animation-'+index);
    });

    this.smScene = new ScrollMagic.Scene({
      triggerHook: 'onLeave',
      duration: this.duration
    }).addTo(this.smController);

    if(this.options?.debug)
      this.smScene.addIndicators();

    this.smScene.on('progress', event => {
      this.editionsEls.forEach((el, index) => {
        this.animations['animation-'+ index].anim.seek( this._getTimingWithDelay(event.progress) );
      });
    });

    if(!Utils.isMobileView()) {
      if(window.scrollY < window.innerHeight/2) {
        setTimeout( () => {
          window.scrollTo({top: window.innerHeight/2, behavior: 'smooth'});

          setTimeout( () => {
            let i = 0;
            let scrollY = 30;
            let isReturning = false;

            let intervalAnim = setInterval(() => {
              this.editionsEls[0].querySelector('.prev-editions__row-gallery .simplebar-content-wrapper').scrollTo(i, 0);

              if (isReturning) {
                if (i === 0)
                  clearInterval(intervalAnim);

                i -= 1;
              }
              if(i <= scrollY && !isReturning) {
                if (i >= scrollY)
                  isReturning = true;

                i += 1;
              }
            }, 10);
          }, 500);
        }, 500);
      }
      if(window.scrollY >= document.documentElement.scrollHeight - document.documentElement.clientHeight*1.5) {
        window.scrollTo({top: document.documentElement.scrollHeight - document.documentElement.clientHeight*1.5, behavior: 'smooth'});
      }
    }

    let rafForResizeId = undefined;
    window.addEventListener('resize', event => {
      rafForResizeId = Utils.debouncedRequestAnimationFrame(rafForResizeId, () => this._resizeHandler());
    });

    let rafForScrollId = undefined;
    window.addEventListener('scroll', event => {
      rafForScrollId = Utils.debouncedRequestAnimationFrame(rafForScrollId, () => this._scrollHandler());
    });
  }

  _getTimingWithDelay(progress) {
    const durationWithOverlapAnimations = this._getDelayOnAnim( this.editionsEls.length - 1) + (this.animationsDuration / this.editionsEls.length);
    const timing = progress * this.animationsDuration;

    return Utils.mapNumber(timing, 0, this.animationsDuration, 0, durationWithOverlapAnimations);
  }

  _getDelayOnAnim(index) {
    return (this.animationsDuration / this.editionsEls.length) / 4 * index;
  }

  _scrollHandler() {
    const scrollPercentage = window.scrollY / (document.documentElement.scrollHeight - document.documentElement.clientHeight);
  }

  _resizeHandler() {
    this.editionHeaderHeight = this.oneEditionHeaderEl.getBoundingClientRect().height;
    this.fullEditionHeight = this.editionsShadowEls[0].getBoundingClientRect().height;

    this.duration = document.documentElement.scrollHeight - document.documentElement.clientHeight;

    this.editionsEls.forEach((el, index) => {
      this._initAnimation('animation-'+index);
    });

    this.smScene.duration(this.duration);

    const currentProgress = this.smScene.progress();

    this.editionsEls.forEach((el, index) => {
      this.animations['animation-'+ index].anim.seek( this._getTimingWithDelay(currentProgress) );
    });
  }

  _initAnimation(animName) {
    this.animations[animName].anim = anime(this.animations[animName].params);
  }

}

export default PrevEditions;
